import { set as setActionType } from "../types"

export default function set(key, value) {
  return {
    type: setActionType,
    key,
    value,
  }
}
